import React, { useState } from "react";

interface CollapsibleSectionProps {
  title: React.ReactNode;
  defaultOpen?: boolean;
  /** true = non-collapsible (always open, no arrow) */
  fixed?: boolean;
  children: React.ReactNode;
}

export default function CollapsibleSection({ title, defaultOpen = false, fixed = false, children }: CollapsibleSectionProps) {
  const [open, setOpen] = useState(defaultOpen);

  return (
    <div className="bg-white rounded-[14px] shadow-[0_4px_48px_rgba(0,0,0,0.05)] overflow-hidden">
      <div
        className={[
          "flex items-center justify-between select-none h-13.5 px-5 transition-colors duration-150 ease-out",
          fixed ? "" : "cursor-pointer hover:bg-gray-50/70 active:bg-gray-100/60",
          (fixed || open) ? "border-b border-[#F2F2F2]" : "",
        ].join(" ")}
        onClick={() => !fixed && setOpen((v) => !v)}
      >
        <h5 className="font-gmarket m-0 text-base font-semibold">{title}</h5>
        {!fixed && (
          <svg
            width="22"
            height="22"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#888"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            className={["transition-transform duration-200 ease-out", open ? "rotate-180" : ""].join(" ")}
          >
            <polyline points="6 9 12 15 18 9" />
          </svg>
        )}
      </div>
      <div className={fixed || open ? "p-5" : "hidden"}>
        {children}
      </div>
    </div>
  );
}
